import React__default from 'react';
import PropTypes from 'prop-types';
import { brands } from '../../tools/constants.js';

var propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  ariaDescribedBy: PropTypes.string,
  /**
   *  autocomplete attribute identifies the type of data needed
   *  from the user so that the field can be accurately autofilled.
   *  Add it to prevent accessibility issues.
   */
  autoComplete: PropTypes.string,
  brand: PropTypes.oneOf(brands),
  children: PropTypes.node,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  maxLength: PropTypes.number,
  value: PropTypes.string
};
function Textarea(_ref) {
  var ariaDescribedBy = _ref.ariaDescribedBy,
    autoComplete = _ref.autoComplete,
    brand = _ref.brand,
    children = _ref.children,
    id = _ref.id,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    label = _ref.label,
    maxLength = _ref.maxLength,
    onChange = _ref.onChange,
    value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "textarea",
    "data-brand": brand,
    "data-testid": "textarea"
  }, /*#__PURE__*/React__default.createElement("textarea", {
    autoComplete: autoComplete,
    "aria-describedby": ariaDescribedBy || null,
    "aria-invalid": isInvalid,
    "aria-required": isRequired || null,
    "data-filled": !!value,
    id: id,
    maxLength: maxLength,
    onChange: onChange,
    required: isRequired,
    value: value
  }), /*#__PURE__*/React__default.createElement("label", {
    className: "float-label",
    htmlFor: id
  }, label), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "placeholder",
    "data-testid": "placeholder"
  }, label), children);
}
Textarea.propTypes = propTypes;

export { Textarea as default };
//# sourceMappingURL=Textarea.js.map
